(function() {
  var scriptEl = document.querySelector('script[src*="section-countdown-timer"][data-section-id]');
  var root = scriptEl ? document.getElementById('CountdownTimer-' + scriptEl.dataset.sectionId) : null;
  if (!root) return;

  var sid = root.dataset.sectionId;
  var endStr = root.dataset.endDate || '';
  var startStr = root.dataset.startDate || '';
  var hideEnd = root.dataset.hideAfterEnd === 'true';
  var daysAfter = parseInt(root.dataset.daysAfterEnd, 10) || 0;
  var rollHrs = parseInt(root.dataset.rollingHours, 10) || 72;
  var cStyle = root.dataset.counterStyle || 'flip';
  var preHeading = root.dataset.preHeading || 'Coming Soon';
  var preSub = root.dataset.preSub || 'Mark your calendar — deals drop soon';
  var noMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* --- Build seasonal decorations via JS with INLINE STYLES --- */
  /* Inline styles bypass Shopify's CSS scoping issues entirely */
  var season = root.dataset.season || 'none';
  var decorContainer = root.querySelector('.ct-decorations');
  var noMotionDecor = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Easter decoration toggles (read fresh each build for editor reactivity) --- */
  function buildEasterDecor() {
    var eggs = root.dataset.easterEggs !== 'false';
    var bunny = root.dataset.easterBunny !== 'false';
    var grass = root.dataset.easterGrass !== 'false';
    var confetti = root.dataset.easterConfetti !== 'false';
    var items = [];
    if (eggs) {
      items.push(
        { style: 'position:absolute;top:10%;left:5%;width:22px;height:30px;border-radius:50% 50% 50% 50%/60% 60% 40% 40%;background:linear-gradient(135deg,#C4B5FD,#A78BFA);transform:rotate(-15deg);opacity:0.7;z-index:3;' },
        { style: 'position:absolute;top:60%;left:12%;width:22px;height:30px;border-radius:50% 50% 50% 50%/60% 60% 40% 40%;background:linear-gradient(135deg,#FBCFE8,#F9A8D4);transform:rotate(20deg);opacity:0.7;z-index:3;' },
        { style: 'position:absolute;top:15%;right:8%;width:22px;height:30px;border-radius:50% 50% 50% 50%/60% 60% 40% 40%;background:linear-gradient(135deg,#FDE68A,#FCD34D);transform:rotate(10deg);opacity:0.7;z-index:3;' },
        { style: 'position:absolute;top:55%;right:5%;width:22px;height:30px;border-radius:50% 50% 50% 50%/60% 60% 40% 40%;background:linear-gradient(135deg,#A78BFA,#7C3AED);transform:rotate(-25deg);opacity:0.7;z-index:3;' }
      );
    }
    if (bunny) {
      items.push({ style: 'position:absolute;bottom:10px;right:10%;width:30px;height:30px;background:rgba(139,92,246,0.3);border-radius:50%;z-index:3;' });
    }
    if (grass) {
      items.push({ style: 'position:absolute;bottom:0;left:0;right:0;height:14px;z-index:3;background:linear-gradient(135deg,transparent 33.33%,rgba(34,197,94,0.4) 33.33%,rgba(34,197,94,0.4) 66.66%,transparent 66.66%),linear-gradient(225deg,transparent 33.33%,rgba(34,197,94,0.3) 33.33%,rgba(34,197,94,0.3) 66.66%,transparent 66.66%);background-size:10px 14px;' });
    }
    if (confetti) {
      items.push(
        { style: 'position:absolute;top:25%;left:20%;width:8px;height:8px;border-radius:50%;background:#C4B5FD;opacity:0.6;z-index:3;animation:ct-confetti-float 5s ease-in-out infinite;' },
        { style: 'position:absolute;top:40%;right:18%;width:8px;height:8px;border-radius:50%;background:#FBCFE8;opacity:0.6;z-index:3;animation:ct-confetti-float 5s ease-in-out 1.5s infinite;' },
        { style: 'position:absolute;top:70%;left:40%;width:8px;height:8px;border-radius:50%;background:#FDE68A;opacity:0.6;z-index:3;animation:ct-confetti-float 5s ease-in-out 3s infinite;' }
      );
    }
    return items;
  }

  /* --- Custom image positioning for uploaded GIFs/images --- */
  var IMG_POS_MAP = {
    'top-left': 'position:absolute;top:8%;left:5%;',
    'top-center': 'position:absolute;top:8%;left:50%;transform:translateX(-50%);',
    'top-right': 'position:absolute;top:8%;right:5%;',
    'middle-left': 'position:absolute;top:50%;left:5%;transform:translateY(-50%);',
    'middle-right': 'position:absolute;top:50%;right:5%;transform:translateY(-50%);',
    'bottom-left': 'position:absolute;bottom:8%;left:5%;',
    'bottom-center': 'position:absolute;bottom:8%;left:50%;transform:translateX(-50%);',
    'bottom-right': 'position:absolute;bottom:8%;right:5%;'
  };

  function getEasterCustomImages() {
    var images = [];
    for (var i = 1; i <= 3; i++) {
      var url = root.dataset['easterImg' + i] || '';
      if (!url) continue;
      var pos = root.dataset['easterImg' + i + 'Pos'] || 'top-left';
      var size = parseInt(root.dataset['easterImg' + i + 'Size'], 10) || 60;
      var animate = root.dataset['easterImg' + i + 'Anim'] !== 'false';
      var posStyle = IMG_POS_MAP[pos] || IMG_POS_MAP['top-left'];
      var style = posStyle + 'width:' + size + 'px;height:auto;z-index:4;pointer-events:none;opacity:0.85;';
      if (animate) style += 'animation:ct-decor-float 3s ease-in-out ' + ((i - 1) * 0.5) + 's infinite;';
      images.push({ url: url, style: style });
    }
    return images;
  }

  var CHRISTMAS_DECOR = [
    { name: 'snow1', style: 'position:absolute;left:8%;width:5px;height:5px;background:rgba(255,255,255,0.8);border-radius:50%;z-index:3;animation:ct-snowfall 3s linear infinite;' },
    { name: 'snow2', style: 'position:absolute;left:22%;width:4px;height:4px;background:rgba(255,255,255,0.7);border-radius:50%;z-index:3;animation:ct-snowfall 4s linear 0.5s infinite;' },
    { name: 'snow3', style: 'position:absolute;left:40%;width:5px;height:5px;background:rgba(255,255,255,0.8);border-radius:50%;z-index:3;animation:ct-snowfall 3.5s linear 1s infinite;' },
    { name: 'snow4', style: 'position:absolute;left:55%;width:3px;height:3px;background:rgba(255,255,255,0.6);border-radius:50%;z-index:3;animation:ct-snowfall 5s linear 1.5s infinite;' },
    { name: 'snow5', style: 'position:absolute;left:70%;width:5px;height:5px;background:rgba(255,255,255,0.8);border-radius:50%;z-index:3;animation:ct-snowfall 4s linear 0.8s infinite;' },
    { name: 'snow6', style: 'position:absolute;left:85%;width:4px;height:4px;background:rgba(255,255,255,0.7);border-radius:50%;z-index:3;animation:ct-snowfall 4.5s linear 2s infinite;' },
    { name: 'star', style: 'position:absolute;top:10px;left:50%;transform:translateX(-50%);width:20px;height:20px;clip-path:polygon(50% 0%,61% 35%,98% 35%,68% 57%,79% 91%,50% 70%,21% 91%,32% 57%,2% 35%,39% 35%);background:#FFD700;opacity:0.8;z-index:3;' }
  ];

  var HALLOWEEN_DECOR = [
    { name: 'moon', style: 'position:absolute;top:10px;right:6%;width:70px;height:70px;border-radius:50%;background:#FDE68A;box-shadow:0 0 30px rgba(253,230,138,0.6),0 0 80px rgba(253,230,138,0.3);z-index:3;opacity:1;' },
    { name: 'pumpkin', style: 'position:absolute;bottom:12px;left:8%;width:34px;height:28px;background:#F97316;border-radius:50%;opacity:0.7;z-index:3;' },
    { name: 'ghost', style: 'position:absolute;bottom:15px;right:18%;width:22px;height:28px;background:rgba(255,255,255,0.25);border-radius:50% 50% 0 0;z-index:3;animation:ct-ghost-float 3s ease-in-out infinite;' },
    { name: 'web', style: 'position:absolute;top:0;left:0;width:60px;height:60px;opacity:0.3;z-index:3;border-right:1px solid rgba(255,255,255,0.6);border-bottom:1px solid rgba(255,255,255,0.6);border-radius:0 0 100% 0;' }
  ];

  var THANKSGIVING_DECOR = [
    { name: 'leaf1', style: 'position:absolute;left:10%;width:12px;height:16px;border-radius:0 80% 0 80%;background:#DC2626;opacity:0.6;z-index:3;animation:ct-leaf-fall 4s linear infinite;' },
    { name: 'leaf2', style: 'position:absolute;left:30%;width:12px;height:16px;border-radius:0 80% 0 80%;background:#F97316;opacity:0.6;z-index:3;animation:ct-leaf-fall 5s linear 1s infinite;' },
    { name: 'leaf3', style: 'position:absolute;left:50%;width:12px;height:16px;border-radius:0 80% 0 80%;background:#D97706;opacity:0.6;z-index:3;animation:ct-leaf-fall 4.5s linear 0.5s infinite;' },
    { name: 'leaf4', style: 'position:absolute;left:70%;width:12px;height:16px;border-radius:0 80% 0 80%;background:#DC2626;opacity:0.6;z-index:3;animation:ct-leaf-fall 3.5s linear 2s infinite;' },
    { name: 'leaf5', style: 'position:absolute;left:88%;width:12px;height:16px;border-radius:0 80% 0 80%;background:#F59E0B;opacity:0.6;z-index:3;animation:ct-leaf-fall 5.5s linear 1.5s infinite;' }
  ];

  var SUMMER_DECOR = [
    { name: 'sun', style: 'position:absolute;top:-8px;right:8%;width:50px;height:50px;border-radius:50%;background:#FBBF24;box-shadow:0 0 25px rgba(251,191,36,0.6);opacity:0.7;z-index:3;animation:ct-sun-pulse 4s ease-in-out infinite;' },
    { name: 'wave', style: 'position:absolute;bottom:0;left:0;right:0;height:16px;opacity:0.4;z-index:3;background:repeating-linear-gradient(90deg,transparent,transparent 12px,rgba(14,165,233,0.6) 12px,rgba(14,165,233,0.6) 24px);' }
  ];

  var JULY4_DECOR = [
    { name: 'star1', style: 'position:absolute;top:12%;left:5%;width:16px;height:16px;clip-path:polygon(50% 0%,61% 35%,98% 35%,68% 57%,79% 91%,50% 70%,21% 91%,32% 57%,2% 35%,39% 35%);background:#fff;opacity:0.6;z-index:3;' },
    { name: 'star2', style: 'position:absolute;top:20%;left:16%;width:12px;height:12px;clip-path:polygon(50% 0%,61% 35%,98% 35%,68% 57%,79% 91%,50% 70%,21% 91%,32% 57%,2% 35%,39% 35%);background:#fff;opacity:0.6;z-index:3;' },
    { name: 'star3', style: 'position:absolute;top:10%;right:10%;width:14px;height:14px;clip-path:polygon(50% 0%,61% 35%,98% 35%,68% 57%,79% 91%,50% 70%,21% 91%,32% 57%,2% 35%,39% 35%);background:#fff;opacity:0.6;z-index:3;' },
    { name: 'stripes', style: 'position:absolute;bottom:0;left:0;right:0;height:8px;z-index:3;background:repeating-linear-gradient(90deg,rgba(220,38,38,0.5) 0,rgba(220,38,38,0.5) 20px,transparent 20px,transparent 40px,rgba(255,255,255,0.4) 40px,rgba(255,255,255,0.4) 60px,transparent 60px,transparent 80px);' }
  ];

  var SEASON_DECOR_MAP = {
    christmas: CHRISTMAS_DECOR,
    halloween: HALLOWEEN_DECOR,
    thanksgiving: THANKSGIVING_DECOR,
    summer: SUMMER_DECOR,
    july4: JULY4_DECOR
  };

  function buildDecorations(s) {
    if (!decorContainer) return;
    decorContainer.innerHTML = '';

    if (s === 'easter') {
      /* Easter: toggle-controlled built-in decorations */
      buildEasterDecor().forEach(function(item) {
        var el = document.createElement('div');
        el.style.cssText = noMotionDecor ? item.style.replace(/animation:[^;]+;/g, '') : item.style;
        el.setAttribute('aria-hidden', 'true');
        decorContainer.appendChild(el);
      });
      /* Custom uploaded GIF/image decorations */
      getEasterCustomImages().forEach(function(img) {
        var el = document.createElement('img');
        el.src = img.url;
        el.style.cssText = noMotionDecor ? img.style.replace(/animation:[^;]+;/g, '') : img.style;
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('loading', 'lazy');
        el.setAttribute('alt', '');
        decorContainer.appendChild(el);
      });
      return;
    }

    var items = SEASON_DECOR_MAP[s];
    if (!items) return;
    items.forEach(function(item) {
      var el = document.createElement('div');
      el.style.cssText = noMotionDecor ? item.style.replace(/animation:[^;]+;/g, '') : item.style;
      el.setAttribute('aria-hidden', 'true');
      decorContainer.appendChild(el);
    });
  }
  buildDecorations(season);

  /* Watch for Shopify editor class changes to update decorations live */
  if (typeof MutationObserver !== 'undefined') {
    var classObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'class') {
          var classes = root.className;
          var newSeason = 'none';
          var seasons = ['easter','christmas','halloween','thanksgiving','summer','july4'];
          for (var i = 0; i < seasons.length; i++) {
            if (classes.indexOf('countdown-timer--' + seasons[i]) !== -1) {
              newSeason = seasons[i];
              break;
            }
          }
          if (newSeason !== season) {
            season = newSeason;
            buildDecorations(season);
          }
        }
      });
    });
    classObserver.observe(root, { attributes: true, attributeFilter: ['class'] });
  }

  var digitContainers = {
    days: root.querySelector('[data-digits="days"]'),
    hours: root.querySelector('[data-digits="hours"]'),
    minutes: root.querySelector('[data-digits="minutes"]'),
    seconds: root.querySelector('[data-digits="seconds"]')
  };
  var clockEl = root.querySelector('.countdown-timer__clock');
  var expiredEl = root.querySelector('.countdown-timer__expired');
  var preStartEl = root.querySelector('.countdown-timer__pre-start');
  var textGroup = root.querySelector('.countdown-timer__text-group');
  var rowEl = root.querySelector('.countdown-timer__row');

  /* --- Digit maps for dot matrix (5x7) --- */
  var DIGIT_MAP = {
    '0': [0,1,1,1,0, 1,0,0,0,1, 1,0,0,1,1, 1,0,1,0,1, 1,1,0,0,1, 1,0,0,0,1, 0,1,1,1,0],
    '1': [0,0,1,0,0, 0,1,1,0,0, 0,0,1,0,0, 0,0,1,0,0, 0,0,1,0,0, 0,0,1,0,0, 0,1,1,1,0],
    '2': [0,1,1,1,0, 1,0,0,0,1, 0,0,0,0,1, 0,0,1,1,0, 0,1,0,0,0, 1,0,0,0,0, 1,1,1,1,1],
    '3': [0,1,1,1,0, 1,0,0,0,1, 0,0,0,0,1, 0,0,1,1,0, 0,0,0,0,1, 1,0,0,0,1, 0,1,1,1,0],
    '4': [0,0,0,1,0, 0,0,1,1,0, 0,1,0,1,0, 1,0,0,1,0, 1,1,1,1,1, 0,0,0,1,0, 0,0,0,1,0],
    '5': [1,1,1,1,1, 1,0,0,0,0, 1,1,1,1,0, 0,0,0,0,1, 0,0,0,0,1, 1,0,0,0,1, 0,1,1,1,0],
    '6': [0,1,1,1,0, 1,0,0,0,0, 1,1,1,1,0, 1,0,0,0,1, 1,0,0,0,1, 1,0,0,0,1, 0,1,1,1,0],
    '7': [1,1,1,1,1, 0,0,0,0,1, 0,0,0,1,0, 0,0,1,0,0, 0,1,0,0,0, 0,1,0,0,0, 0,1,0,0,0],
    '8': [0,1,1,1,0, 1,0,0,0,1, 1,0,0,0,1, 0,1,1,1,0, 1,0,0,0,1, 1,0,0,0,1, 0,1,1,1,0],
    '9': [0,1,1,1,0, 1,0,0,0,1, 1,0,0,0,1, 0,1,1,1,1, 0,0,0,0,1, 0,0,0,0,1, 0,1,1,1,0]
  };

  /* --- Build per-digit DOM element based on style --- */
  function createDigitEl(ch) {
    if (cStyle === 'flip') return createFlipCard(ch);
    if (cStyle === 'dotmatrix') return createDotGrid(ch);
    if (cStyle === 'bold') return createBoldDigit(ch);
    return createMinimalDigit(ch);
  }

  function createFlipCard(ch) {
    var card = document.createElement('div');
    card.className = 'ct-flip-card';
    card.dataset.val = ch;
    /* Static halves show current value */
    card.innerHTML =
      '<div class="ct-half ct-half-top"><span>' + ch + '</span></div>' +
      '<div class="ct-half ct-half-bottom"><span>' + ch + '</span></div>';
    return card;
  }

  function flipDigit(card, newCh) {
    if (noMotion) {
      card.dataset.val = newCh;
      card.querySelector('.ct-half-top span').textContent = newCh;
      card.querySelector('.ct-half-bottom span').textContent = newCh;
      return;
    }
    var oldCh = card.dataset.val;
    if (oldCh === newCh) return;
    card.dataset.val = newCh;

    /* Remove any in-progress flaps */
    var oldFlaps = card.querySelectorAll('.ct-flap');
    for (var i = 0; i < oldFlaps.length; i++) oldFlaps[i].remove();
    card.classList.remove('is-flipping');

    /*
     * Correct flip sequence:
     * 1. flap-top sits ON TOP of static-top, showing OLD value. It will fold down.
     * 2. Update static-top to NEW value (hidden behind flap-top until it folds away).
     * 3. flap-bottom shows NEW value, starts rotated 90deg (hidden). It unfolds to cover static-bottom.
     * 4. static-bottom still shows OLD value — covered by flap-bottom when it unfolds.
     * 5. After animation: remove flaps, update static-bottom to NEW.
     */

    var flapTop = document.createElement('div');
    flapTop.className = 'ct-flap ct-flap-top';
    flapTop.innerHTML = '<span>' + oldCh + '</span>';

    var flapBottom = document.createElement('div');
    flapBottom.className = 'ct-flap ct-flap-bottom';
    flapBottom.innerHTML = '<span>' + newCh + '</span>';

    /* Update static top to NEW (hidden behind flap-top) */
    card.querySelector('.ct-half-top span').textContent = newCh;
    /* Static bottom keeps OLD (will be covered by flap-bottom) */

    card.appendChild(flapTop);
    card.appendChild(flapBottom);

    /* Force reflow then animate */
    void card.offsetWidth;
    card.classList.add('is-flipping');

    /* After full animation (600ms + buffer), clean up */
    setTimeout(function() {
      card.classList.remove('is-flipping');
      card.querySelector('.ct-half-bottom span').textContent = newCh;
      var flaps = card.querySelectorAll('.ct-flap');
      for (var j = 0; j < flaps.length; j++) flaps[j].remove();
    }, 700);
  }

  function createDotGrid(ch) {
    var grid = document.createElement('div');
    grid.className = 'ct-dot-grid';
    grid.dataset.val = ch;
    var map = DIGIT_MAP[ch] || DIGIT_MAP['0'];
    for (var i = 0; i < 35; i++) {
      var dot = document.createElement('div');
      dot.className = map[i] ? 'ct-dot ct-dot--on' : 'ct-dot';
      grid.appendChild(dot);
    }
    return grid;
  }

  function updateDotGrid(grid, newCh) {
    if (grid.dataset.val === newCh) return;
    grid.dataset.val = newCh;
    var map = DIGIT_MAP[newCh] || DIGIT_MAP['0'];
    var dots = grid.children;
    for (var i = 0; i < 35; i++) {
      dots[i].className = map[i] ? 'ct-dot ct-dot--on' : 'ct-dot';
    }
  }

  function createMinimalDigit(ch) {
    var el = document.createElement('div');
    el.className = 'ct-minimal-digit';
    el.textContent = ch;
    el.dataset.val = ch;
    return el;
  }

  function createBoldDigit(ch) {
    var el = document.createElement('span');
    el.className = 'ct-bold-digit';
    el.textContent = ch;
    el.dataset.val = ch;
    return el;
  }

  function updateSimpleDigit(el, newCh) {
    if (el.dataset.val === newCh) return;
    el.dataset.val = newCh;
    el.textContent = newCh;
  }

  /* --- Pad number to string of specified width --- */
  function pad(n, w) { var s = String(n); while (s.length < w) s = '0' + s; return s; }

  /* --- Update a digit container with a padded value --- */
  var prevStrings = { days: '', hours: '', minutes: '', seconds: '' };

  function updateUnit(key, value, width) {
    var str = pad(value, width);
    if (str === prevStrings[key]) return;
    prevStrings[key] = str;
    var container = digitContainers[key];
    if (!container) return;

    var children = container.children;
    /* Grow or shrink digit count if needed (days can go from 2 to 3 digits) */
    while (children.length < str.length) {
      container.appendChild(createDigitEl('0'));
    }
    while (children.length > str.length) {
      container.removeChild(container.lastChild);
    }

    for (var i = 0; i < str.length; i++) {
      var digitEl = children[i];
      var ch = str[i];
      if (cStyle === 'flip') flipDigit(digitEl, ch);
      else if (cStyle === 'dotmatrix') updateDotGrid(digitEl, ch);
      else updateSimpleDigit(digitEl, ch);
    }
  }

  /* --- Initialize digit containers with zeros --- */
  function initDigits() {
    var units = { days: 2, hours: 2, minutes: 2, seconds: 2 };
    for (var key in units) {
      var container = digitContainers[key];
      if (!container) continue;
      container.innerHTML = '';
      for (var i = 0; i < units[key]; i++) {
        container.appendChild(createDigitEl('0'));
      }
    }
  }

  /* --- Copy to clipboard --- */
  function doCopy(code, btn) {
    var lb = btn.querySelector('[data-copy-label]');
    var orig = lb ? lb.textContent : 'Copy';
    function ok() {
      if (lb) lb.textContent = 'Copied!';
      btn.classList.add('is-copied');
      setTimeout(function() { if (lb) lb.textContent = orig; btn.classList.remove('is-copied'); }, 2000);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(ok).catch(function() { fallbackCopy(code, ok); });
    } else { fallbackCopy(code, ok); }
  }
  function fallbackCopy(t, cb) {
    var a = document.createElement('textarea');
    a.value = t; a.style.cssText = 'position:fixed;opacity:0';
    document.body.appendChild(a); a.focus(); a.select();
    try { document.execCommand('copy'); cb(); } catch (e) {}
    document.body.removeChild(a);
  }

  root.querySelectorAll('[data-copy-code]').forEach(function(b) {
    b.addEventListener('click', function() { doCopy(b.getAttribute('data-copy-code'), b); });
  });
  var codeEl = root.querySelector('[data-discount-code]');
  if (codeEl) {
    var cpBtn = root.querySelector('[data-copy-code]');
    function triggerCopy() { if (cpBtn) cpBtn.click(); }
    codeEl.addEventListener('click', triggerCopy);
    codeEl.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); triggerCopy(); } });
  }

  /* --- Pre-start teaser state --- */
  function showPreStart(targetDate) {
    if (textGroup) textGroup.hidden = true;
    if (preStartEl) {
      preStartEl.hidden = false;
      preStartEl.querySelector('.countdown-timer__pre-heading').textContent = preHeading;
      preStartEl.querySelector('.countdown-timer__pre-sub').textContent = preSub;
    }
    initDigits();
    runCountdown(targetDate, function() {
      /* Start date reached — switch to active mode */
      if (preStartEl) preStartEl.hidden = true;
      if (textGroup) textGroup.hidden = false;
      startActiveCountdown();
    });
  }

  /* --- Determine end target and start countdown --- */
  function startActiveCountdown() {
    var tEnd = null;
    var rolling = false;

    if (endStr) {
      tEnd = new Date(endStr);
      if (isNaN(tEnd.getTime())) return;
    } else {
      rolling = true;
      var lk = 'ct_rolling_' + sid;
      var sv = null;
      try { sv = localStorage.getItem(lk); } catch (e) {}
      if (sv) {
        var se = new Date(sv);
        if (!isNaN(se.getTime()) && se > new Date()) tEnd = se;
      }
      if (!tEnd) {
        tEnd = new Date(Date.now() + rollHrs * 3600000);
        try { localStorage.setItem(lk, tEnd.toISOString()); } catch (e) {}
      }
    }

    initDigits();
    runCountdown(tEnd, function() {
      if (rolling) {
        tEnd = new Date(Date.now() + rollHrs * 3600000);
        try { localStorage.setItem('ct_rolling_' + sid, tEnd.toISOString()); } catch (e) {}
        initDigits();
        startActiveCountdown();
        return;
      }
      var ge = new Date(tEnd.getTime() + daysAfter * 86400000);
      if (hideEnd && new Date() > ge) { root.hidden = true; return; }
      if (clockEl) clockEl.hidden = true;
      if (expiredEl) expiredEl.hidden = false;
    });
  }

  /* --- Generic countdown runner --- */
  function runCountdown(targetDate, onEnd) {
    function tick() {
      var diff = targetDate.getTime() - Date.now();
      if (diff <= 0) {
        updateUnit('days', 0, 2);
        updateUnit('hours', 0, 2);
        updateUnit('minutes', 0, 2);
        updateUnit('seconds', 0, 2);
        clearInterval(tm);
        if (onEnd) onEnd();
        return;
      }
      var ts = Math.floor(diff / 1000);
      var d = Math.floor(ts / 86400);
      updateUnit('days', d, d > 99 ? 3 : 2);
      updateUnit('hours', Math.floor((ts % 86400) / 3600), 2);
      updateUnit('minutes', Math.floor((ts % 3600) / 60), 2);
      updateUnit('seconds', ts % 60, 2);
    }
    tick();
    var tm = setInterval(tick, 1000);
  }

  /* --- Entry point: check pre-start vs active --- */
  if (startStr) {
    var sd = new Date(startStr);
    if (!isNaN(sd.getTime()) && new Date() < sd) {
      showPreStart(sd);
    } else {
      initDigits();
      startActiveCountdown();
    }
  } else {
    initDigits();
    startActiveCountdown();
  }
})();
